import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { SportsMultiViewBlock } from "./SportsMultiViewBlock";
import { SportsMultiViewBlockData } from "./data";
/*
let PageMethodsMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-resp-lib/lib/mocks");
    PageMethodsMock = _.PageMethodsMock;
}*/
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
import * as LOCALMOCKS from "../../mocks";

let _: typeof MOCKSTYPE;
let _localMocks: typeof LOCALMOCKS;

let StatisticsContentProviderMock;
let SportContentProviderMock;
let BetSlipUtilMock;
let OddsMock;
let NavHandlerMock;
let GameStatusMock;
let TimeControlMock;

if (process.env.NODE_ENV === "development") {
    _ = require("sb-resp-lib/lib/mocks");
    _localMocks = require("../../mocks");
    StatisticsContentProviderMock = _localMocks.StatisticsContentProviderMock;
    SportContentProviderMock = _localMocks.SportContentProviderMock;
    BetSlipUtilMock = _.BetSlipUtilMock;
    OddsMock = _.OddsMock;
    NavHandlerMock = _.NavHandlerMock;
    GameStatusMock = _.GameStatusMock;
    TimeControlMock = _.TimeControlMock;
}

export class SportsMultiViewBlockRoot extends BaseBlock {
    dataProvider!: SportsMultiViewBlockData;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {
                sportsProvider: {},
                statisticsProvider: {},
                branchesConfigData: {}
            },
            betSlipUtil: {},
            oddsUtil: {},
            gameStatus: {},
            timeControl: {},
            facade: {},
            panelId: "",
        }
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {

            // setup data mocks for debug build
            this.dataProvider = new SportsMultiViewBlockData({
                sportsProvider: new SportContentProviderMock(),
                statisticsProvider: new StatisticsContentProviderMock(true, 1),
                branchesConfigData: _localMocks.BranchConfigDataMock,
                utils: {
                    betSlipUtil: new BetSlipUtilMock(),
                    oddsUtil: new OddsMock()
                },
                gameStatus: new GameStatusMock(),
                timeControl: new TimeControlMock(new Date()),
                startLiveBettingInMinutes: 5
            }, new NavHandlerMock());

            // setup dictionary for debug build
            this.options.dict = BaseDict;

            // setup cms
            this.options.cms = _localMocks.CMSMock;

            //export data store to window for debug purposes
            window["SportsMultiViewBlockDATA"] = this.dataProvider;
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            // use pagemethods passed during the construction from the
            // mobile application

            this.dataProvider = new SportsMultiViewBlockData({
                sportsProvider: this.options.dataProvider.sportsProvider,
                statisticsProvider: this.options.dataProvider.statisticsProvider,
                branchesConfigData: this.options.dataProvider.branchesConfigData,
                utils: {
                    betSlipUtil: this.options.betSlipUtil,
                    oddsUtil: this.options.oddsUtil
                },
                gameStatus: this.options.gameStatus,
                timeControl: this.options.timeControl,
                startLiveBettingInMinutes: this.options.dataProvider.startLiveBettingInMinutes
            }, this.options.navHandler);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };

        // merge default and CMS options
        this.options.cms = { ...config, ...(options.cms || {}) };
    }

    activate() {

        if (this.dataProvider.currentBranchId === "0" || this.isActive) { return this }

        this.dataProvider.activate();

        return super.activate(
            <SportsMultiViewBlock dataProvider={this.dataProvider} dict={this.options.dict} cms={this.options.cms} />
        );
    }

    updateFromPush(data) {
        this.dataProvider.updateFromPush(data);
    }
}

window["SportsMultiViewBlock"] = SportsMultiViewBlockRoot;
broadcastBlockLoad("SportsMultiViewBlock");